var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stepper-header"},_vm._l((_vm.steps),function(label,index){return _c('div',{key:index,staticClass:"step-item"},[_c('div',{class:[
        'step-label',
        {
          active: index <= _vm.currentStepIndex,
          clickable: label !== 'Completed' && !_vm.isPreview
        }
      ],on:{"click":function($event){return _vm.handleStepClick(label, index)}}},[_vm._v(" "+_vm._s(label)+" ")]),(index < _vm.steps.length - 1)?_c('div',{class:['divider', { active: index < _vm.currentStepIndex }]}):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }